import { JobsTypes, SingleJobsType } from "./jobsType";


export const initialState: JobsTypes = {
  fetching: false,
  jobTypeFetching: false,
  error: null,
  message: "",
  success: null,
  sharedJobSuccess: null,
  statusCode: null,
  jobsTypeList: [] as any,
  totalJobsTypeCount: 0,
  singleJobsDetails: {},
  singleJobs: {},
  singleRecurringJobsDetails: {},
  NonRecurringJobsList: [] as any,
  singleJobsType: {} as SingleJobsType,
  jobsTypeListTotalCount: 0,
  totalJobsCount: 0,
  totalRecurringJobsListCount: 0,
  jobsList: [],
  futureJobsList:[],
  recurringResponsiblePeople: [],
  documentsLinkList: [],
  jobProgressCommentsList: [],
  jobProgressCommentsFetching: false,
  jobProgressCommentsSuccess: null,
  assignedClientsOpenJobsList: [],
  uniqueCheckFetching: false,
  uniqueCheckSuccess: null,
  uniqueCheckError: null,
  uniqueCheckMessage: "",
  isJobType: null,
  uniqueCheckStatusCode: null,
  assignedClientsShareOpenJobsList: [],
  totalAllOpenJobsCount: 0,
  totalAllOpenShareJobsCount: 0,
  jobChecklistData:[],
  jobChecklistSingleData:null,
  jobChecklistCount:0,
  allOpenJobChecklistSingleData:null,
  allOpenJobChecklistData:[],
  allOpenJobChecklistCount:0,
  allCommentDueTomorrowListData:[],
  allCommentDueTomorrowCount:0,
  recurringJobReportList:[],
  recurringJobReportTotalCount:0
}